import { RouteManager } from './routeManager';

export const routeManager = new RouteManager();
